const UploadPercent = ({ row, id, content }) => {
  if (row.original.uploadPercent === 0 && !row.original?.uploadPercentColor) return
  if (!row.original.uploadPercent  && !row.original?.uploadPercentColor) return
    return <span className={`badge badge-pill badge-${row?.original?.uploadPercentColor}`}>DOCS {row.original.uploadPercent}%</span>
}

export default UploadPercent
